import { IconType, SvgIcon } from './SvgIcon';

export const CircleFilledCheckIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22ZM12 7C12.6 7 13 7.4 13 8C13 8.6 12.6 9 12 9C11.4 9 11 8.6 11 8C11 7.4 11.4 7 12 7ZM11 12C11 11.4 11.4 11 12 11C12.6 11 13 11.4 13 12V16C13 16.6 12.6 17 12 17C11.4 17 11 16.6 11 16V12Z"
      fill="currentColor"
    />
  </SvgIcon>
);

CircleFilledCheckIcon.displayName = 'CircleCheckIcon';
